import { ViewDensity, ViewType } from "@common/types/views/views";
import {
    HistoryCatalogItemDetailsColumn,
    HistoryCatalogItemDetailsView,
    HistoryCatalogItemTableKind,
} from "./historyCatalogItemDetailsView";

const COLUMNS_BY_KIND: Record<
    HistoryCatalogItemTableKind,
    HistoryCatalogItemDetailsColumn[]
> = {
    [HistoryCatalogItemTableKind.IDENTITY]: [
        HistoryCatalogItemDetailsColumn.TIME,
        HistoryCatalogItemDetailsColumn.ITEM_NAME,
        HistoryCatalogItemDetailsColumn.PREVIOUS,
        HistoryCatalogItemDetailsColumn.MODIFIED,
    ],
    [HistoryCatalogItemTableKind.CHANGE]: [
        HistoryCatalogItemDetailsColumn.TIME,
        HistoryCatalogItemDetailsColumn.ITEM_NAME,
        HistoryCatalogItemDetailsColumn.FIELD,
        HistoryCatalogItemDetailsColumn.PREVIOUS,
        HistoryCatalogItemDetailsColumn.MODIFIED,
    ],
};

export const createDefaultHistoryCatalogItemDetailsView = (
    kind: HistoryCatalogItemTableKind,
): HistoryCatalogItemDetailsView => ({
    type: ViewType.HISTORY_UPDATED_TRANSACTION,
    columns: COLUMNS_BY_KIND[kind].map((id) => ({ id })),
    filters: {},
    options: {
        selection: true,
        density: ViewDensity.MD,
    },
});
